// noinspection JSDeprecatedSymbols

(function ($) {

	// let initAlignments = function () {
	// 	const body = document.querySelector('body');
	// 	const scrollbar = window.innerWidth - body.clientWidth;
	// 	body.setAttribute("style", `--scrollbar: ${scrollbar}px`);
	// };

	let initNav = function () {
		let navExposedMediaQuery = '(min-width: 62.5rem)';
		let siteHeader = $('#siteHeader');
		let primaryNav = $('#siteNav');
		let siteSearch = $('#siteHeader__search');

		$('.siteHeader__button', '#siteHeader').on('click', function (e) {
			e.preventDefault();
			let isOpen = $(this).attr('aria-expanded');
			let targetID = $(this).attr('aria-controls');
			let target;

			if (targetID) {
				target = $('#' + targetID);
			}

			if (isOpen === 'true') {
				target.hide();

				$(this).attr('aria-expanded', 'false').removeClass('is-active');
			} else {
				$('.siteHeader__button').not(this).attr('aria-expanded', 'false').removeClass('is-active');
				$([primaryNav, siteSearch]).each(function () {
					$(this).hide()
				});

				if (target === 'siteNav') {
					siteHeader.addClass('has-active-nav');
				}
				target.show();

				$(this).attr('aria-expanded', 'true').addClass('is-active');

				if (targetID === 'siteHeader__search') {
					$('input[type="search"], input[type="text"]', siteSearch).focus();
				}
			}
		});

		$('#searchform').on('submit', function (e) {
			let query = $(this).find('#s').val();

			if (!query.trim()) {
				e.preventDefault();

				$(this).find('input').eq(0).focus();
			}
		});

		$('details', '#siteNav').on('toggle', function (e) {
			let details = e.currentTarget;
			let isOpening = details.open;
			let isDesktop = window.matchMedia(navExposedMediaQuery).matches;

			if (isDesktop) {
				if (isOpening) {
					$('details', '#siteNav').not(this).removeAttr('open');
				}

				let anyOpen = $('details[open]', '#siteNav');

				if (anyOpen.length) {
					siteHeader.addClass('has-active-nav');
				} else {
					siteHeader.removeClass('has-active-nav');
				}
			}
		});

	};

// --

	$(document).ready(function () {
		initNav();
		// initAlignments();
	});

	$(window).on('load', function () {
		// correct anything loaded on DOM load which might need adjusting (mostly once images have loaded)
	});


// $(window).smartResize(function () {
//   // events that need to fire after a window resize (or device rotation)
//   Waypoint.refreshAll();
// });

})
(jQuery);
